var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWandEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.821 55.1001H87.7508ZM92.7431 17.9665L75.6979 35.0118ZM55.6099 22.9591V6.88867ZM35.5221 35.0123L18.4768 17.967ZM23.4689 55.1001H7.39844ZM35.5221 75.1882L18.4768 92.2333ZM55.6099 103.312V87.241ZM143.997 143.488L79.7156 79.2058Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.821 55.1001H87.7508M92.7431 17.9665L75.6979 35.0118M55.6099 22.9591V6.88867M35.5221 35.0123L18.4768 17.967M23.4689 55.1001H7.39844M35.5221 75.1882L18.4768 92.2333M55.6099 103.312V87.241M143.997 143.488L79.7156 79.2058",
    stroke: "white",
    strokeWidth: 12.0529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWandEmoji);
export default __webpack_public_path__ + "static/media/wand-emoji.f7c79f776f4f3ceaa4abdfd4af3e13c3.svg";
export { ForwardRef as ReactComponent };